import React, { useEffect } from 'react';

import { Flex } from '@chakra-ui/react';
import { addYears, startOfDay } from 'date-fns';
import { useSelectedView } from 'reducers/viewsSlice';
import { useLevelUpAnalytics } from 'screens/analytics/continuousFeedback/context';

import { thisQuarter } from 'constants/ProjectConstants';
import { getDateRangeFromLS } from 'constants/helper';
import { localStorageKeys } from 'constants/localStorageKeys';

import { DateRangeDropdown } from 'uiToolkitV1/DateRange';
import { TextHeader2 } from 'uiToolkitV1/Typography';

import { HeaderMarginContainer } from '../HeaderComponents/HeaderMarginContainer';

const CFAnalyticsHeader = ({ headerLabel }) => {
  const { updateDateRange } = useLevelUpAnalytics();

  const sideNavSelectedCohort = useSelectedView();

  useEffect(() => {
    // this is to set default date range in context.
    const dateRangeFromLS = getDateRangeFromLS(localStorageKeys.analyticsFeedbackFilters);
    updateDateRange(dateRangeFromLS ?? thisQuarter);
  }, []);

  return (
    <HeaderMarginContainer>
      {/* <Box pb={2}> */}
      <Flex alignItems="center" h="48px">
        {Boolean(sideNavSelectedCohort?.name) && (
          <TextHeader2 mr="8px" bold>
            {/* eslint-disable-next-line react/jsx-no-useless-fragment */}
            <>{headerLabel ? `${headerLabel} for` : `${sideNavSelectedCohort?.name}'s feedback for`}</>
          </TextHeader2>
        )}
        <DateRangeDropdown
          onSelect={updateDateRange}
          minDate={new Date(2020, 5, 1, 0, 0, 0, 0)}
          maxDate={addYears(startOfDay(new Date()), 5)}
          initialDateRange={getDateRangeFromLS(localStorageKeys.analyticsFeedbackFilters) ?? thisQuarter}
          showPredefinedRanges
          definedRanges={undefined}
        />
      </Flex>
      {/* </Box> */}
    </HeaderMarginContainer>
  );
};

export default CFAnalyticsHeader;
